import actions from './moduleLeadsActions';
import getters from './moduleLeadsGetters';
import mutations from './moduleLeadsMutations';
import state from './moduleLeadsState';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
